<template>
  <div v-if="isFooterRow">
    <v-button class="add-symbol" variant="link" @click="params.context.openSymbolSearchDialog($event.target)"
      ><font-awesome-icon :icon="['fas', 'plus-circle']" /> {{ params.context.i18n('buttonAddSymbol') }}</v-button
    >
  </div>
  <div v-else class="full-width-row">
    <span class="sr-only">{{ i18n('rowButton') }}</span>
    <v-dropdown
      boundary="window"
      ref="dropdown"
      detached
      menu-class="c-function-button-menu-layer"
      no-caret
      toggle-class="function-button"
      @click.native.stop
    >
      <template v-slot:button-content>
        <font-awesome-icon :icon="['far', 'ellipsis-v']" />
        <span class="sr-only"
          >{{ i18n('emptyRow', 'widgets.watchlist.functionButtonMenu') }}-{{ i18n('rowButton') }}</span
        >
      </template>
      <v-dropdown-item @click="onDeleteRow">
        <font-awesome-icon :icon="['far', 'trash-alt']" /> {{ i18n('delete') }}
      </v-dropdown-item>
    </v-dropdown>
    <span v-if="isRowDraggable" class="ag-icon ag-icon-grip custom-drag" unselectable="on" role="presentation"></span>
  </div>
</template>

<script>
import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
fontAwesomeLibrary.add(faPlusCircle);

export default {
  name: 'full-width-row-renderer',
  computed: {
    isFooterRow() {
      return this.params.data.isFooterRow;
    },
    isRowDraggable() {
      const state = this.$store.state.widget[this.params.wid];
      return !state.autosort || state.customTickerSort;
    }
  },
  methods: {
    i18n(subkey, ns) {
      if (!ns) {
        ns = 'components.functionButtonMenu';
      }
      return this.$t(`white-label.${ns}.${subkey}`);
    },
    async onDeleteRow() {
      this.$refs.dropdown.hide(false);
      await this.$nextTick();
      this.params.context.removeSymbols(this.params.node);
    }
  },
  mounted() {
    this.params.registerRowDragger(this.params.eParentOfValue, undefined, this.params.data.name, true);
  }
};
</script>
<style lang="scss" scoped>
.add-symbol.btn-link:focus {
  border: 1px solid get-color('primary', 'lighten-2');
  height: 21px;
}
.full-width-row {
  margin: 2px;
}
.custom-drag {
  margin: -1.1em 1.6em;
  width: 11px;
  overflow: hidden;
  cursor: grab;
}
</style>
